export const objectValuesToArray = (models) => {
  if (!models) return [];

  const iterableModels = [];
  const keys = Object.keys(models);
  keys.forEach((k) => {
    const member = models[k];
    iterableModels.push(member);
  });

  return iterableModels;
};

export const dereference = (anObject) => {
  // Clone a thing in order to break references to it
  return JSON.parse(JSON.stringify(anObject));
};

export const isObject = (thing) => {
  return (
    thing !== null && typeof thing === "object" && thing.constructor === Object
  );
};
